/* eslint-disable check-file/filename-blocklist -- pre-existing .jsx; this change only swaps an icon import, converting to .tsx is a separate migration */
import React from 'react';
import {
  Flex,
  Text,
  Icon,
  Box,
  Tooltip,
  Center,
  Collapse,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
} from '@chakra-ui/react';
import { AccordionIcon } from '@chakra-ui/react';
import { KText } from '@/ui-library/components';
import { ChevronDown, ChevronRight, InfoCircle } from '@kula-ai/icons-core';

//note: using custom collapse, instead of chakra collapse, because of scroll issue in select

const DefaultHeaderComp = ({
  onClick,
  isOpen,
  headerConfig = {},
  title = 'Section Title Placeholder',
  isHeaderClickable = false,
  showInfoIcon = false,
  infoText = '',
}) => {
  const { textStyles, containerStyles = () => {}, iconStyles } = headerConfig;
  return (
    <Flex
      onClick={isHeaderClickable && onClick ? onClick : () => {}}
      cursor={isHeaderClickable && onClick ? 'pointer' : 'unset'}
      justifyContent="space-between"
      {...containerStyles(isOpen)}
      alignItems="center"
    >
      <Flex gap="6px" alignItems="center">
        <Text {...textStyles}>{title}</Text>
        {showInfoIcon && (
          <Tooltip variant="default" label={infoText}>
            <Center w="16px " h="16px">
              <Icon as={InfoCircle} color="secondary-700" />
            </Center>
          </Tooltip>
        )}
      </Flex>
      {onClick && (
        <Icon
          cursor="pointer"
          as={isOpen ? ChevronDown : ChevronRight}
          onClick={() => onClick()}
          {...iconStyles}
        />
      )}
    </Flex>
  );
};

const V2HeaderComp = ({
  onClick,
  isOpen,
  title = 'Section Title Placeholder',
  showInfoIcon = false,
  infoText = '',
  headerRightContent = null,
  showRightBorder = true,
  headerConfig = {},
  headerStyles = {},
}) => {
  const { textStyles = () => {} } = headerConfig;
  const { iconStyles = {}, ...restStyles } = headerStyles;
  return (
    <AccordionButton
      w="100%"
      _focus={{ boxShadow: 'none' }}
      borderBottom={isOpen && '1px solid'}
      borderColor="border-color"
      justifyContent="space-between"
      p="0"
      h="54px"
      bg="secondary-25"
      _hover={{}}
      borderTopRadius="xs"
      borderBottomRadius={isOpen ? '0' : 'xs'}
      onClick={onClick}
      {...restStyles}
    >
      <Center
        w="54px"
        h="100%"
        borderRight={showRightBorder ? '1px solid' : 'none'}
        borderColor={showRightBorder ? 'border-color' : 'transparent'}
        {...iconStyles}
      >
        <AccordionIcon />
      </Center>
      <Flex w="100%" justifyContent="space-between" alignItems="center">
        <Flex flex="1" alignItems="center" gap="6px">
          <KText px="12px" color="secondary-900" {...textStyles}>
            {title}
          </KText>
          {showInfoIcon && (
            <Tooltip variant="default" label={infoText}>
              <Center w="16px" h="16px" mr="12px">
                <Icon as={InfoCircle} color="secondary-700" />
              </Center>
            </Tooltip>
          )}
        </Flex>
        {headerRightContent && (
          <Flex alignItems="center" mr="16px">
            {headerRightContent}
          </Flex>
        )}
      </Flex>
    </AccordionButton>
  );
};

export const CollapseSection = (props) => {
  const {
    HeaderComp,
    children,
    defaultIsOpen = false,
    styles,
    enableOnclick = true,
    collapseStyles,
    accordionItemProps,
    isV2 = false,
    title,
    showInfoIcon,
    infoText,
    headerRightContent,
    headerLeftContent,
    headerStyles,
    ...rest
  } = props;

  const [isOpen, setIsOpen] = React.useState(defaultIsOpen);

  const handleToggle = () => {
    if (enableOnclick) {
      setIsOpen(!isOpen);
    }
  };

  if (isV2) {
    return (
      <Accordion
        allowToggle
        index={isOpen ? [0] : []}
        reduceMotion
        allowMultiple={false}
        gap="12px"
        display="flex"
        flexDir="column"
        {...styles}
        {...rest}
      >
        <AccordionItem
          border="1px solid"
          borderColor="var(--kula-colors-border-color) !important"
          borderRadius="xs"
          overflow="hidden"
          {...accordionItemProps}
        >
          {() => (
            <>
              <V2HeaderComp
                onClick={handleToggle}
                isOpen={isOpen}
                title={title}
                showInfoIcon={showInfoIcon}
                infoText={infoText}
                isHeaderClickable={enableOnclick}
                headerRightContent={headerRightContent}
                headerLeftContent={headerLeftContent}
                headerStyles={headerStyles}
                {...rest}
              />
              <AccordionPanel p="0" style={collapseStyles} {...collapseStyles}>
                {children}
              </AccordionPanel>
            </>
          )}
        </AccordionItem>
      </Accordion>
    );
  }

  const FinalHeaderComp = HeaderComp ?? DefaultHeaderComp;

  return (
    <Box {...styles}>
      <FinalHeaderComp onClick={handleToggle} isOpen={isOpen} {...props} />
      <Collapse
        in={isOpen}
        unmountOnExit={false}
        animateOpacity
        transition={{
          enter: { duration: 0.3, ease: 'easeInOut' },
          exit: { duration: 0.2, ease: 'easeInOut' },
        }}
        style={{
          overflow: 'hidden',
          position: 'relative',
        }}
      >
        <Box
          position="relative"
          style={{
            ...collapseStyles,
          }}
        >
          {children}
        </Box>
      </Collapse>
    </Box>
  );
};
